import * as ko from 'knockout'
import { ScratchedDeductionsViewModel as viewModel } from './ScratchedDeductionsViewModel'
import template from './scratched-deductions.tpl.html'

if (!ko.components.isRegistered('display-scratched-deductions')) {
  ko.components.register('display-scratched-deductions', { viewModel, template })
}
